export default {
  DateTime: 'datetime',
  String: 'string',
  Date: 'date',
  Monetary: 'monetary',
  Boolean: 'boolean',
  Number: 'number'
};
